module.exports = __webpack_public_path__ + "static/media/icon-red-question-mark-circle.64a3b5e9.svg";